import React from 'react';
import './Magazine.css';

const Magazine = () => {
    const pdfPath = '/assets/images/img/magazine.pdf';
    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = process.env.PUBLIC_URL + pdfPath;
        link.download = 'E-Magazine.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <div className="container">
            <div className="pdf-header">
                <h3>E-Magazine</h3>
            </div>
            <div className="pdf-viewer">
                <iframe
                    title="PDF Viewer"
                    src={process.env.PUBLIC_URL + pdfPath}
                    width="100%"
                    frameBorder="0"
                    className='pdfframe'
                />
                <button className="download-btn" onClick={handleDownload}>
                    Download PDF
                </button>
            </div>
        </div>
    );
};

export default Magazine;